import { PropsWithChildren } from 'react';
import React from 'react';
import './ResponsiveColumns.scss';
import classNames from 'classnames';

export type ResponsiveColumnsProps = PropsWithChildren<{
    className?: string;
    width: number;
    breaks: number[];
}>;

export const RcRowName = 'rc-row';
export const RcColumnName = 'rc-column';

const Row = (props: PropsWithChildren<{ className?: string }>) => (
    <div className={classNames(RcRowName, props.className)}>
        {props.children}
    </div>
);

const Column = (props: PropsWithChildren<{ fullWidth?: boolean }>) => (
    <div className={`${RcColumnName}${props?.fullWidth ? ' full-width' : ''}`}>
        {props.children}
    </div>
);

interface ResponsiveColumnsComponent
    extends React.FunctionComponent<ResponsiveColumnsProps> {
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Row: React.FunctionComponent<PropsWithChildren<{ className?: string }>>;
    // eslint-disable-next-line @typescript-eslint/naming-convention
    Column: React.FunctionComponent<PropsWithChildren<{ fullWidth?: boolean }>>;
}

export const ResponsiveColumns: ResponsiveColumnsComponent = (
    props: ResponsiveColumnsProps
) => {
    const { children, className, width, breaks } = props;

    let columnCount = 1;

    for (const br of breaks) {
        if (width < br) {
            break;
        }
        columnCount++;
    }

    const cssClasses = classNames(
        'ResponsiveColumns',
        `cols-${columnCount}`,
        className
    );

    return <div className={cssClasses}>{children}</div>;
};

ResponsiveColumns.Row = Row;
ResponsiveColumns.Column = Column;
